import FormFieldGroupKeys from 'forms-utils-lib/constants/formFieldGroup/FormFieldGroupKeys';
import RichTextKeys from 'forms-utils-lib/constants/formFieldGroup/RichTextKeys';
const createFormFieldGroup = ({
  field,
  richText = {
    [RichTextKeys.CONTENT]: ''
  },
  isSmartGroup = false,
  isPageBreak = false,
  default: defaultParam = true
}) => ({
  [FormFieldGroupKeys.FIELDS]: field ? [field] : [],
  [FormFieldGroupKeys.DEFAULT]: defaultParam,
  isSmartGroup,
  richText,
  isPageBreak
});
export default createFormFieldGroup;